import css from './pill.module.scss'
export const Pill = ({text, className = '', haveBg = false}) => {
  return (
    <div className={`${css.pill} ${haveBg ? css.pillBg : ''} ${className}`}>{text}</div>
  )
}